<template>
    <div class="company">
        <Navbar/>
        <div class="main-img">
            <img src="../assets/company/main.jpg" />
            <div class="main-text" id="aboutUs">
                <h3>About Us</h3>
                <img src="../assets/common/logo_onestep.png"/>
                <p>ONESTEP Technology was established in 2009 and now become one of the leading 3D visualization technology companies especially pioneering in real-time and streaming visualized interactive technologies.</p>
                <p>We accumulated and aimed to help our clients provide end customers more friendly and easy-to-access experience via innovative and fast-evolving real-time visualization technologies.</p>
            </div>
        </div>
        <div class="img-list">
            <img src="../assets/company/company-1.jpg"/>
            <img src="../assets/company/company-2.jpg"/>
        </div>
        <div class="lifecycle" id="solutionMatrix">
            <h4>Solution Matrix</h4>
            <h3>Automotive Product Lifecycle</h3>
            <div class="tabs">
                <ul id="tab-list">
                    <li>
                        <span class="current">Design</span>
                        <img src="../assets/company/circle-white.png"/>
                        <img src="../assets/company/circle-blue.png"/>
                    </li>
                    <li>
                        <span>Clinic</span>
                        <img src="../assets/company/circle-white.png"/>
                        <img src="../assets/company/circle-blue.png"/>
                    </li>
                    <li>
                        <span>Development</span>
                        <img src="../assets/company/circle-white.png"/>
                        <img src="../assets/company/circle-blue.png"/>
                    </li>
                    <li>
                        <span>Sales & Marketing</span>
                        <img src="../assets/company/circle-white.png"/>
                        <img src="../assets/company/circle-blue.png"/>
                    </li>
                    <li>
                        <span>Aftersales</span>
                        <img src="../assets/company/circle-white.png"/>
                        <img src="../assets/company/circle-blue.png"/>
                    </li>
                </ul>
                <div class="lines">
                    <img src="../assets/company/v-line.png"/>
                </div>
            </div>
            <div class="content">
                <div class="tabs-con">
                    <span>3D Data Asset<br/>Digital Asset Management</span>
                    <img src="../assets/company/lifecycle-1.jpg" />
                </div>
                <div class="tabs-con">
                    <span>Design Collaboration<br/>Multi-user Car Clinic</span>
                    <img src="../assets/company/lifecycle-2.jpg" />
                </div>
                <div class="tabs-con">
                    <span>Real-time HMI Development</span>
                    <img src="../assets/company/lifecycle-3.jpg" />
                </div>
                <div class="tabs-con">
                    <span>Digital Customer Journey and Tools</span>
                    <img src="../assets/company/lifecycle-4.jpg" />
                </div>
                <div class="tabs-con">
                    <span>Training</span>
                    <img src="../assets/company/lifecycle-5.jpg" />
                </div>
            </div>
        </div>
        <div class="contact" id="contactUs">
            <h4>Contact Us</h4>
            <div class="bg-con">
                <img id="img-bg" src="../assets/company/contact-bg.jpg" />
                <ul>
                    <li>
                        <img src="../assets/company/icon-email.png"/>
                        <span>x5@industryillusion.com</span>
                    </li>
                    <li>
                        <img src="../assets/company/icon-tel.png"/>
                        <span>（86）021-52658752</span>
                    </li>
                </ul>
            </div>
            <div class="address">
                <div class="address-box">
                    <img src="../assets/company/icon-address.png" />
                    <h3>Shanghai</h3>
                    <p>7th floor, Building B, Puluona Plaza, No.2145, Jinshajiang Road, Shanghai, China</p>
                </div>
                <div class="v-line"></div>
                <div class="address-box">
                    <img src="../assets/company/icon-address.png" />
                    <h3>Suzhou</h3>
                    <!-- <p>12th floor, Huoli Building, No.185, Jumao Road, Suzhou, China</p> -->
                </div>
            </div>
        </div>
        <GoTop/>
        <Footer/>
    </div>
</template>
<script>
import $ from 'jquery'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import GoTop from '@/components/GoTop.vue'
export default {
  name: 'company',
  components: {
    Navbar,
    Footer,
    GoTop
  },
  mounted(){
    this.$nextTick(()=>[
        this.goAnchor(window.location.hash)
    ])
  },
  methods: {
    changeTabs () {
      const tabs = document.querySelectorAll('#tab-list > li')
      const tabsName = document.querySelectorAll('#tab-list > li > span')
      const circleBlue = document.querySelectorAll('#tab-list > li > img:nth-of-type(2)')
      const tabCon = document.querySelectorAll('.tabs-con')
      tabCon[0].style.display = 'block'
      circleBlue[0].style.display = 'block'
      for (let i = 0; i < tabs.length; i++) {
        tabs[i].onclick = function () {
          for (let t = 0; t < tabCon.length; t++) {
            tabCon[t].style.display = 'none'
            tabsName[t].classList.remove('current')
            circleBlue[t].style.display = 'none'
          }
          tabCon[i].style.display = 'block'
          tabsName[i].classList.add('current')
          circleBlue[i].style.display = 'block'
        }
      }
    },
    goAnchor(selector) {
        let anchor = this.$el.querySelector(selector)
        document.documentElement.scrollTop = anchor.offsetTop 
    },
  },
  mounted: function () {
    this.changeTabs()
    // 滚动位置
    // var hash = window.location.hash
    // var index = hash.lastIndexOf('#')
    // if (index !== -1) {
    //   var id = hash.substring(index + 1, hash.length + 1)
    //   var div = document.getElementById(id)
    //   if (div) {
    //     setTimeout(function () {
    //       $('html, body').animate({ scrollTop: $(div).offset().top - 50 }, 200)
    //     }, 500)
    //   }
    // }
  },
  watch: {
    $route: {
        handler: function(to, form){
            this.goAnchor(window.location.hash)
        },
        //立即先去执行handler方法
        immediate:true
    }
  },
}
</script>
<style lang="stylus" scoped>
.main-img
    width 100%
    background #000
    img
        width 100%
    .main-text
        text-align center
        margin-top -3rem
        padding-top 3rem
        padding-bottom 2rem
        h3
            font-size 2rem
            color #5F5F5F
            text-transform uppercase
            font-weight 500
            margin-bottom 2rem
        img
            width 30rem
        p
            width 70rem
            margin 2rem auto
            font-size 1.2rem
            color #B4B4B4
            word-break keep-all
            word-wrap break-word
            white-space pre-wrap
.img-list
    width 100%
    display flex
    flex-flow row nowrap
    img
        width 50%
.lifecycle
    width 100%
    background  #1E1E1E
    text-align center
    padding-top 8rem
    h4
        color #5F5F5F
        font-size 1.8rem
        font-weight 500
        text-transform uppercase
    h3
        color #fff
        font-size 3rem
        text-transform uppercase
        margin-top 1rem
    .tabs
        width 90%
        text-align center
        margin 8rem auto 2rem auto
        .lines
            height 2px
            margin-top 1rem
            img
                width 100%
        ul
            margin 0
            padding 0 8rem
            list-style none
            display flex
            flex-flow row nowrap
            justify-content space-between
            li
                text-align center
                position relative
                span
                    font-size 1.5rem
                    color #fff
                    text-transform uppercase
                    cursor pointer
                .current
                    color #11A9FB
                img:nth-of-type(1)
                    width 1rem
                    position absolute
                    left 50%
                    margin-left -.5rem
                    bottom -2.5rem
                    z-index 1
                    cursor pointer
                img:nth-of-type(2)
                    width 1.6rem
                    position absolute
                    left 50%
                    margin-left -.8rem
                    bottom -2.8rem
                    z-index 2
                    display none
    .content
        width 90%
        margin 0 auto
        .tabs-con
            display none
            text-align left
            span
                font-size 1.4rem
                color #B4B4B4
                display block
            img
                width 50rem
                margin-top 2rem
        .tabs-con:nth-of-type(1)
            margin-left 0rem
            span
                width 20rem
                text-align center
        .tabs-con:nth-of-type(2)
            margin-left 6%
            span
                width 20rem
                margin-left 10%
                text-align center
        .tabs-con:nth-of-type(3)
            margin-left 25%
            span
                width 20rem
                margin-left 12%
                text-align center
        .tabs-con:nth-of-type(4)
            margin-left 35%
            span
                width 25rem
                margin-left 30%
                text-align center
        .tabs-con:nth-of-type(5)
            margin-left 55%
            span
                width 20rem
                margin-left 53%
                text-align center
.contact
    padding-top 10rem
    background #1E1E1E
    text-align center
    h4
        color #5F5F5F
        font-size 1.6rem
        font-weight 500
        text-transform uppercase
        margin-bottom 5rem
    .bg-con
        position relative
        display inline-block
        margin 0 auto
        #img-bg
            height 27rem
            position relative
            z-index 1
            margin 0  -100rem
        ul
            width 30rem
            margin 0 0 0 10rem
            padding 0
            list-style none
            position absolute
            left 50%
            top 9rem
            z-index 2
            li
                width 100%
                text-align left
                margin 2rem 0 0 0
                img
                    width 3rem
                    vertical-align middle
                span
                    font-size 1.4rem
                    color #fff
                    margin-left 1rem
                    vertical-align middle
    .address
        display flex
        flex-flow row nowrap
        justify-content space-between
        padding 8rem 20%
        .address-box
            text-align center
            img
                width 4rem
            h3
                font-size 1.6rem
                color #fff
                text-transform uppercase
                margin-top 1rem
                font-weight 500
            p
                width 30rem
                font-size 1.2rem
                color rgba(255,255,255,.8)
                word-break keep-all
                word-wrap break-word
                white-space pre-wrap
                margin-top 2rem
        .v-line
            width 0
            height 8rem
            font-size 0
            border-right 1px solid rgba(255,255,255,.6)
            margin-top 3rem
</style>
